import RootReducer from "./reducers/RootReducer";
import {configureStore} from "@reduxjs/toolkit";

let devtools = x => x;

if (
    process.env.NODE_ENV !== "production" &&
    process.browser &&
    window.__REDUX_DEVTOOLS_EXTENSION__
) {
    devtools = window.__REDUX_DEVTOOLS_EXTENSION__();
}

const store = configureStore({
    reducer: RootReducer,
    devTools: devtools,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false,
    })
});
export default store